import { useAppointmentStore } from "../stores/appointmentsStore";
import { useDateStore } from "../stores/datestore";
import { watch } from "vue";
import axios, { Axios } from "axios";

export function useMarkedStylists() {
  const apptStore = useAppointmentStore();
  const dateStore = useDateStore();

  watch(
    () => dateStore.selectedDate,
    () => {
      axios({
        method: "get",
        url: "/api/assignedstylists",
        params: {
          date: dateStore.getISODate,
        },
      }).then((response) => {
        if (response.data.length === 0) return;
        apptStore.markedStylists = response.data;
        // apptStore.addMSFromDB(markedStylists);
      });
    },
    { immediate: true }
  );
}
